import { render, staticRenderFns } from "./InspectQuestion.vue?vue&type=template&id=226e2300&scoped=true"
import script from "./InspectQuestion.vue?vue&type=script&lang=ts"
export * from "./InspectQuestion.vue?vue&type=script&lang=ts"
import style0 from "./InspectQuestion.vue?vue&type=style&index=0&id=226e2300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e2300",
  null
  
)

export default component.exports